import React, { Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

//import { BrowserRouter } from "react-router-dom";
//import { GuardProvider, GuardedRoute } from "react-router-guards";

// Componentes de autenticación (no lazy - necesarios inmediatamente)
import Login from "./components/login.component";
import GuardedRoute from "./security/GuardedRoute";
import GuardedPublicRoute from "./security/GuardedPublicRoute";
import AuthService from "./services/auth.service";

// Lazy loading de componentes
// const Register = React.lazy(() => import("./components/register.component"));
const Profile = React.lazy(() => import("./components/profile.component"));
// const BoardUser = React.lazy(() => import("./components/board-user.component"));
// const BoardModerator = React.lazy(() => import("./components/board-moderator.component"));
// const BoardAdmin = React.lazy(() => import("./components/board-admin.component"));

// Trabajador
const ListTrabajador = React.lazy(() =>
  import("./components/view/Trabajador").then(module => ({ default: module.ListTrabajador }))
);
const CreateTrabajador = React.lazy(() =>
  import("./components/view/Trabajador").then(module => ({ default: module.CreateTrabajador }))
);
const ListaTrabajadoresCabecilla = React.lazy(() =>
  import("./components/view/Trabajador").then(module => ({ default: module.ListaTrabajadoresCabecilla }))
);

// Producto
const ListProducto = React.lazy(() =>
  import("./components/view/Producto").then(module => ({ default: module.ListProducto }))
);
const CreateProducto = React.lazy(() =>
  import("./components/view/Producto").then(module => ({ default: module.CreateProducto }))
);

// Asignacion
const ListaAsignacion = React.lazy(() =>
  import("./components/view/Asignacion").then(module => ({ default: module.ListaAsignacion }))
);
const CreateAsignacionCabecilla = React.lazy(() =>
  import("./components/view/Asignacion").then(module => ({ default: module.CreateAsignacionCabecilla }))
);
const CreateAsignacionIndividual = React.lazy(() =>
  import("./components/view/Asignacion").then(module => ({ default: module.CreateAsignacionIndividual }))
);

// Usuarios
const CreateUsuario = React.lazy(() =>
  import("./components/view/Usuarios").then(module => ({ default: module.CreateUsuario }))
);
const ListUsuario = React.lazy(() =>
  import("./components/view/Usuarios").then(module => ({ default: module.ListUsuario }))
);

// Vencidos
const ListaVencidos = React.lazy(() =>
  import("./components/view/Vencidos").then(module => ({ default: module.ListaVencidos }))
);

// Realizados
const ListaRealizados = React.lazy(() =>
  import("./components/view/Realizados").then(module => ({ default: module.ListaRealizados }))
);
const DetalleRealizados = React.lazy(() =>
  import("./components/view/Realizados").then(module => ({ default: module.DetalleRealizados }))
);

// Otros
const ListaAsignacionTotalCabecillas = React.lazy(() =>
  import("./components/view/ListaTotalProdCabecilla/TotalRealizadosCab")
);
const ListaPuntuacion = React.lazy(() =>
  import("./components/view/Puntuacion").then(module => ({ default: module.ListaPuntuacion }))
);

// Cuentas
const ListCuentas = React.lazy(() =>
  import("./components/view/Cuentas").then(module => ({ default: module.ListCuentas }))
);
const Movimientos = React.lazy(() =>
  import("./components/view/Cuentas").then(module => ({ default: module.Movimientos }))
);

// Reportes
const ListaReportes = React.lazy(() => import('./components/view/Reportes/index'));

// Componente de Loading centralizado
const LoadingFallback = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "400px",
    }}
  >
    <CircularProgress />
  </Box>
);

const Routes = () => {
  const currentUser = AuthService.getCurrentUser();

  return (
    <React.Fragment>
      <Suspense fallback={<LoadingFallback />}>
        <Switch>
        {/*<Route exact path={["/", "/home"]} component={Login} />*/}

        <GuardedRoute exact path="/" auth={currentUser}>
          <Redirect to="/asignacion" />
        </GuardedRoute>

        <GuardedPublicRoute
          path="/login"
          component={Login}
          auth={currentUser}
        />
        {/*<Route exact path="/register" component={Register} />*/}
        {/*<Route exact path="/profile" component={Profile} />*/}
        {/*<Route path="/user" component={BoardUser} />*/}

        {/* User */}
        <GuardedRoute path="/profile" component={Profile} auth={currentUser} />

        {/* Usuarios */}

        <GuardedRoute
          path="/usuarios"
          component={ListUsuario}
          auth={currentUser}
        />

        <GuardedRoute
          path="/usuario/create"
          component={CreateUsuario}
          auth={currentUser}
        />

        <GuardedRoute
          path="/usuario/edit/:id"
          component={CreateUsuario}
          auth={currentUser}
        />

        {/* Trabajador */}
        <GuardedRoute
          path="/trabajadores"
          component={ListTrabajador}
          auth={currentUser}
        />

        <GuardedRoute
          path="/trabajadores_cabecilla/:id"
          component={ListaTrabajadoresCabecilla}
          auth={currentUser}
        />

        <GuardedRoute
          path="/trabajador/create"
          component={CreateTrabajador}
          auth={currentUser}
        />

        <GuardedRoute
          path="/trabajador/edit/:id"
          component={CreateTrabajador}
          auth={currentUser}
        />

        {/* Producto */}

        <GuardedRoute
          path="/productos"
          component={ListProducto}
          auth={currentUser}
        />

        <GuardedRoute
          path="/producto/create"
          component={CreateProducto}
          auth={currentUser}
        />

        <GuardedRoute
          path="/producto/edit/:id"
          component={CreateProducto}
          auth={currentUser}
        />

        {/* Asignacion */}
        <GuardedRoute
          path="/asignacion"
          component={ListaAsignacion}
          auth={currentUser}
        />

        <GuardedRoute
          path="/asignacion_individual/create"
          component={CreateAsignacionIndividual}
          auth={currentUser}
        />

        <GuardedRoute
          path="/asignacion_cabecilla/create"
          component={CreateAsignacionCabecilla}
          auth={currentUser}
        />

        {/* Cuentas */}
        <GuardedRoute
          path="/cuentas"
          component={ListCuentas}
          auth={currentUser}
        />

        <GuardedRoute
          path="/cuenta/:id"
          component={Movimientos}
          auth={currentUser}
        />

        {/* Informes */}
        {/* Vencidos */}

        <GuardedRoute
          path="/vencidos"
          component={ListaVencidos}
          auth={currentUser}
        />

        <GuardedRoute
          path="/realizados"
          component={ListaRealizados}
          auth={currentUser}
        />

        <GuardedRoute
          path="/puntuacion"
          component={ListaPuntuacion}
          auth={currentUser}
        />

        <GuardedRoute
          path="/cabecillasTotal"
          component={ListaAsignacionTotalCabecillas}
          auth={currentUser}
        />

        <GuardedRoute
          path="/detalle_realizados/:tipo/:id/:anio"
          component={DetalleRealizados}
          auth={currentUser}
        />

        {/* Reportes */}

        <GuardedRoute
          path="/reportes"
          component={ListaReportes}
          auth={currentUser}
        />

        {/* NOT FOUND */}
        <Route exact path={["*"]}>
          <Redirect to="/" />
        </Route>
      </Switch>
      </Suspense>
    </React.Fragment>
  );
};

export default Routes;
